document.addEventListener('DOMContentLoaded', () => {
	let isAnimating = false;

	const collapsableCollectionCards = Array.from(
		document.querySelectorAll('.collapsable-collection-card')
	);
	
	function slideToIndex(activeCard, dataIndex) {
		if (isAnimating) return;
	
		const currentActiveContent = activeCard.querySelector(
			'.collapsable-collection-card__content__item__left__content__container.active'
		);
		const currentActiveTextContent = activeCard.querySelector(
			'.collapsable-collection-card__content__item__right__container__content.active'
		);
	
		const newContentToShow = activeCard.querySelector(
			`.collapsable-collection-card__content__item__left__content__container[data-index="${dataIndex}"]`
		);
		const newContentTextToShow = activeCard.querySelector(
			`.collapsable-collection-card__content__item__right__container__content[data-index="${dataIndex}"]`
		);
	
		if (
			!currentActiveContent ||
			!newContentToShow ||
			currentActiveContent === newContentToShow ||
			!currentActiveTextContent ||
			!newContentTextToShow ||
			currentActiveTextContent === newContentTextToShow
		) return;
	
		const from = Number(currentActiveContent.dataset.index);
		const to = Number(dataIndex);
		const goBackward = from > to;
	
		isAnimating = true;
	
		// ==== Prepare incoming slides (NO transition) ====
		newContentToShow.classList.add('active');
		newContentToShow.style.transition = 'none';
		newContentToShow.style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
	
		newContentTextToShow.classList.add('active');
		newContentTextToShow.style.transition = 'none';
		newContentTextToShow.style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
	
		// Force reflow
		void newContentToShow.offsetWidth;
		void newContentTextToShow.offsetWidth;
	
		// Re-enable transition
		newContentToShow.style.transition = '';
		newContentTextToShow.style.transition = '';
	
		// ==== Trigger animations ====
		currentActiveContent.style.transform = goBackward ? 'translateX(100%)' : 'translateX(-100%)';
		newContentToShow.style.transform = 'translateX(0)';
	
		currentActiveTextContent.style.transform = goBackward ? 'translateX(100%)' : 'translateX(-100%)';
		newContentTextToShow.style.transform = 'translateX(0)';
	
		// ==== Cleanup ====
		let finished = 0;
		function onEnd(e) {
			if (e.propertyName !== 'transform') return;
			finished += 1;
	
			// Expect 4 transitions: out+in (left + right)
			if (finished < 4) return;
	
			currentActiveContent.classList.remove('active');
			currentActiveTextContent.classList.remove('active');
	
			// // Reset only the old (outgoing) elements
			// [currentActiveContent, currentActiveTextContent].forEach(el => {
			// 	el.style.transform = '';
			// 	el.removeEventListener('transitionend', onEnd);
			// });

			// // Keep incoming at translateX(0)
			// [newContentToShow, newContentTextToShow].forEach(el => {
			// 	el.style.transform = 'translateX(0)';
			// 	el.removeEventListener('transitionend', onEnd);
			// });

	
			isAnimating = false;
		}
	
		[currentActiveContent, newContentToShow, currentActiveTextContent, newContentTextToShow].forEach(el =>
			el.addEventListener('transitionend', onEnd, { once: true })
		);
	}

	const showCollapsableInfo = (e) => {
		
		const dataId = e.dataset.id;
		const dataIndex = e.dataset.index;
		const collapsableCollectionCard = document.getElementById(dataId);

		// Find the parent card to get chevron elements
		const parentCard = e.closest('.our-collection__card');
		const chevronDown = parentCard.querySelector('.chevron-down');
		const chevronUp = parentCard.querySelector('.chevron-up');
		const chevronButton = parentCard.querySelector('.our-collection__card__chevron');

		// check if the card is active
		const activeCard = collapsableCollectionCards.find(card => card.classList.contains('active'));
		const targetContent = collapsableCollectionCard.querySelector('.collapsable-collection-card__content__item__left__content__container[data-index="' + dataIndex + '"]');
		

		if(!activeCard){
			chevronDown.style.display = 'none';
			chevronUp.style.display = 'block';
			chevronButton.classList.add('active');
			collapsableCollectionCard.classList.add('active');
			if (targetContent) {
				// Ensure the card is active first, then show the content
				collapsableCollectionCard.classList.add('active');
				targetContent.style.transform = 'translateX(0)';
				targetContent.classList.add('active');
				return;
			}

		}

		const activeContent = activeCard.querySelector('.collapsable-collection-card__content__item__left__content__container.active');
			
		// check if the click card is the same as the active card
		if ( activeContent.dataset.index === dataIndex) {
			chevronDown.style.display = 'block';
			chevronUp.style.display = 'none';
			chevronButton.classList.remove('active');
			activeCard.classList.remove('active');

			return;
		}

		slideToIndex(activeCard, dataIndex);
	};

	const onClickCloseSectionBtn = (e) => {
		const dataId = e.dataset.id;
		const collapsableCollectionCard = document.getElementById(dataId);
		
		// chevronDown.style.display = 'block';
		// chevronUp.style.display = 'none';
		// chevronButton.classList.remove('active');
		collapsableCollectionCard.classList.remove('active');
	}

	const cards = document.querySelectorAll('.our-collection__card');
	cards.forEach((card) => {
		card.addEventListener('click', (e) => showCollapsableInfo(e.currentTarget));
	});

	collapsableCollectionCards.forEach((card) => {
		const closeSectionBtns = card.querySelectorAll('.close-section-btn');
		if(closeSectionBtns) {
			closeSectionBtns.forEach((button) => {
				button.addEventListener('click', (e) => onClickCloseSectionBtn(e.currentTarget));
			});
		}
	});

});